import styled from 'styled-components';

const Wrapper = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const text = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
`;

export default {
  Wrapper,
  text,
};
